﻿import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

let TooltipText = styled(Typography)(() => ({
    fontSize: '14px'
}));

export default TooltipText;
